import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4 text-sm text-red-600"
}
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-gray-600"
}
const _hoisted_3 = {
  key: 1,
  class: "space-y-3"
}

import { computed, inject, onMounted } from 'vue'

import NeueLoading from '@/components/neue/NeueLoading.vue'
import { useMarketing } from '@/composables/useMarketing'

import MarketingMonthCard from './MarketingMonthCard.vue'


export default {
  __name: 'MarketingHistory',
  setup(__props) {

const { plans, loading, error, load } = inject('marketing', null) || useMarketing()

const periodOf = plan => plan.attributes?.period_start || ''
const sorted = computed(() => [...plans.value].sort((x, y) => periodOf(y).localeCompare(periodOf(x))))

onMounted(load)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(error))
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(error)), 1))
      : _createCommentVNode("", true),
    _createVNode(NeueLoading, { loading: _unref(loading) }, {
      default: _withCtx(() => [
        (!sorted.value.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, " No months yet. Your first plan shows here once it exists. "))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sorted.value, (plan, i) => {
                return (_openBlock(), _createBlock(MarketingMonthCard, {
                  key: plan.id,
                  plan: plan,
                  collapsed: i >= 2
                }, null, 8, ["plan", "collapsed"]))
              }), 128))
            ]))
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}
}

}